import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        updateForm: '=',
        questionCategory: '=',
        update: '&',
        cancel: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'general.Manage translations' | translate }}</h2>
        </div>
        <div class="modal-body form">
            <form-wrapper form="vm.form">
                <table class="data01">
                    <tr>
                        <th>{{ 'general.Label ' | translate }}</th>
                        <th>{{ vm.defaultLanguage }} <small>({{ 'translation.default' | translate}})</small></th>
                        <th ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <label><input type="checkbox" ng-model="vm.languages[code]"
                            ng-click="vm.toggleCheckbox(code)"> {{ code }}</label>
                        </th>
                    </tr>
                    <tr>
                        <td>{{ 'translation.Category name' | translate }}*</td>
                        <td class="input">
                            <form-row-wide error="vm.form.errors.categoryI18ns[vm.defaultLanguage].name">
                                <div class="items">
                                    <input ng-model="vm.form.model.categoryI18ns[vm.defaultLanguage].name" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <form-row-wide error="vm.form.errors.categoryI18ns[code].name">
                                <div class="items">
                                    <input ng-model="vm.form.model.categoryI18ns[code].name" ng-if="value" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                </table>
            </form-wrapper>
        </div>
        <div class="modal-footer">
        <ul class="actions01">
            <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
            <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
        </ul>
        </div>
    `
})
export default class {
    constructor ($scope, $translate, lodash, TokenService, ModalService, FormFactory) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.lodash = lodash;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.form = FormFactory.create(this.questionCategory, model => model.$update({
            id: model.id,
            expand: 'categoryI18ns'
        }));
    }

    $onInit () {
        this.defaultLanguage = this.TokenService.getCompanyLanguage();
        const companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();

        // this holds all available language codes as key and whether they are activated as value
        this.languages = {};
        this.lodash.forEach(companySupportedLanguages, (code) => {
            this.languages[code] = this.lodash.has(this.questionCategory.categoryI18ns, code);
        });
    }

    toggleCheckbox (code) {
        const confirmMessage = this.$translate.instant('translations.Are you sure you would like to remove this translation?');

        if (!this.languages[code]) {
            // leave checkbox checked
            this.languages[code] = !this.languages[code];
            this.ModalService.confirm(confirmMessage, 'medium')
                .then(() => {
                    // uncheck if confirmed
                    this.languages[code] = !this.languages[code];
                    // if language is disabled, make sure no error messages are left in ui
                    if (this.lodash.has(this.form.errors.categoryI18ns, code)) {
                        delete this.form.errors.categoryI18ns[code];
                    }
                });
        }
        else {
            // if language is enabled and form does not have current i18n, make one
            if (!this.lodash.has(this.form.model.categoryI18ns, code)) {
                this.form.model.categoryI18ns[code] = {};
            }
        }
    }

    deleteDisabledTranslations () {
        this.lodash.forEach(this.languages, (isActive, code) => {
            // if language is not active delete it from form
            if (!isActive && this.lodash.has(this.form.model.categoryI18ns, code)) {
                delete this.form.model.categoryI18ns[code];
            }
        });
    }

    save () {
        this.deleteDisabledTranslations();
        this.form.save()
            .then(() => {
                this.update();
                this.updateForm.model.categoryI18ns = this.form.model.categoryI18ns;
                this.questionCategory.categoryI18ns = this.form.model.categoryI18ns;
            })
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/forms/questioncategories/translation/index.js